const initialState = {
  panel: 'dash',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_DIFF_PANEL':
      return { ...state, panel: action.panel };
    case 'TOGGLE_RECORD_SCRIPT':
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
